import { useMemo } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import type { ConceptDefinition, ConceptsRegistry } from '@/services/api/schemas'
import { ConceptCard } from './ConceptCard'

export function ConceptsBrowser({ registry }: { registry: ConceptsRegistry }) {
  const groups = useMemo(() => {
    const buckets: Record<string, Array<[string, ConceptDefinition]>> = {}
    for (const [id, c] of Object.entries(registry.concepts)) {
      const list = buckets[c.domain] ?? []
      list.push([id, c])
      buckets[c.domain] = list
    }
    for (const list of Object.values(buckets)) list.sort((a, b) => a[0].localeCompare(b[0]))
    return buckets
  }, [registry])

  const domains = Object.keys(groups).sort()

  return (
    <Tabs defaultValue={domains[0]}>
      <TabsList>
        {domains.map(d => (
          <TabsTrigger key={d} value={d}>
            {d}
            <span className="text-muted-foreground ml-1.5 text-xs">{groups[d].length}</span>
          </TabsTrigger>
        ))}
      </TabsList>
      {domains.map(d => (
        <TabsContent key={d} value={d} className="space-y-3">
          {groups[d].map(([id, c]) => (
            <ConceptCard key={id} id={id} concept={c} />
          ))}
        </TabsContent>
      ))}
    </Tabs>
  )
}
